<div class="flex flex-col-reverse gap-4 justify-end lg:-mt-[82px] print:hidden sm:flex-row ml-4">
  <div class="relative flex flex-col">
    <app-simple-pill
      label="Firmen / Personen"
      [filter]="legalEntityFilter | async"
      [filterValues]="legalEntityFilterValues ?? []"
      (filterChanged)="legalEntityFilter.next($event)"
    ></app-simple-pill>

    <div class="flex items-center h-5 mt-1 ml-6">
      <input
        (change)="isGrouped($event)"
        [checked]="isGroupedByCustomer"
        id="groupedByCustomer"
        type="checkbox"
        class="focus:ring-blue-500 h-4 w-4 text-blue-600 border-edge rounded disabled:bg-surface-disabled disabled:checked:bg-blue-400"
      />

      <div class="ml-2 text-xs">
        <label for="groupedByCustomer" class="font-medium text-fg-subtle">Gruppieren</label>
      </div>
    </div>
  </div>
  <app-date-filter-pill
    [filter]="(dateFilter | async)!"
    (filterChanged)="dateFilter.next($event)"
  ></app-date-filter-pill>
</div>

@if (!isGroupedByCustomer) {
  @if (rows$ | async; as rows) {
    @if (rows.length > 0) {
      <div class="bg-surface mt-4 shadow sm:rounded-lg overflow-hidden print:shadow-none">
        <div
          class="grid grid-cols-[minmax(50px,_2fr)_minmax(100px,_1fr)_minmax(100px,_1fr)] sm:grid-cols-[minmax(50px,_1fr)_minmax(50px,_1fr)_minmax(50px,_1fr)_minmax(50px,_2fr)_minmax(100px,_1fr)_minmax(100px,_1fr)] gap-2 p-4 group"
        >
          <div>
            <button
              class="pr-4 flex justify-between w-full text-fg-faint group-hover:text-fg-primary"
              (click)="sortDateToggle()"
            >
              <div class="text-right text-sm font-semibold">Datum</div>
              <app-ng-icon
                class="text-xl"
                name="heroArrowLongDown"
                [class.rotate-180]="(sortDate | async) === 'asc'"
              ></app-ng-icon>
            </button>
          </div>
          <div class="hidden sm:block"></div>
          <div class="hidden sm:block"></div>
          <div class="hidden sm:block"></div>
          <div class="text-right text-sm font-semibold text-fg-primary">Einnahmen</div>
          <div class="text-right text-sm font-semibold text-fg-primary">Ausgaben</div>
        </div>
        @if (rows.length > 15) {
          <ng-container *ngTemplateOutlet="totalRow"></ng-container>
        }
        @for (row of rows; track row.document.id; let first = $first) {
          <button
            (click)="openDocument(row.document)"
            [class.border-t]="first"
            class="w-full border-b border-edge grid grid-cols-[minmax(50px,_2fr)_minmax(100px,_1fr)_minmax(100px,_1fr)] sm:grid-cols-[minmax(50px,_1fr)_minmax(50px,_1fr)_minmax(50px,_1fr)_minmax(50px,_2fr)_minmax(100px,_1fr)_minmax(100px,_1fr)] gap-2 px-4 py-2 sm:p-4 text-sm text-left font-normal text-fg-secondary hover:text-fg-primary hover:bg-surface-hover leading-4 group items-center"
          >
            <div>
              @if (row.category) {
                <app-category-badge
                  class="block sm:hidden mb-2"
                  [color]="row.category.color"
                  [displayName]="row.category.displayName"
                ></app-category-badge>
              }
              {{ row.valueDate | date: 'd. MMM yy' }}
              <div
                class="truncate text-fg-muted block sm:hidden text-xs"
                [class.text-red-600]="row.overdue"
                [class.group-hover:text-red-900]="row.overdue"
              >
                {{ row.document.data.name }}
              </div>
              <div class="truncate block sm:hidden text-xs">
                {{ row.legalEntityDisplayName ? row.legalEntityDisplayName : '-' }}
              </div>
            </div>
            <div class="truncate hidden sm:block">
              @if (row.category) {
                <app-category-badge
                  [color]="row.category.color"
                  [displayName]="row.category.displayName"
                ></app-category-badge>
              }
              @if (!row.category) {
                <span>-</span>
              }
            </div>
            <div class="truncate hidden sm:block">
              {{ row.legalEntityDisplayName ? row.legalEntityDisplayName : '-' }}
            </div>
            <div
              class="truncate font-medium text-fg-muted hidden sm:block"
              [class.text-red-600]="row.overdue"
              [class.group-hover:text-red-900]="row.overdue"
            >
              {{ row.document.data.name }}
            </div>
            <div class="text-right font-mono">
              {{ row.revenue | number: '1.2-2' : 'de-CH' }}
            </div>
            <div class="text-right font-mono">
              {{ row.expense | number: '1.2-2' : 'de-CH' }}
            </div>
          </button>
        }
        <ng-container *ngTemplateOutlet="totalRow"></ng-container>
      </div>
    } @else {
      <app-empty
        message="Keine Einnahmen und Ausgaben erfasst für diesen Zeitraum"
        disableAction
      ></app-empty>
    }
  }
} @else {
  @if (groupedByCustomer$ | async; as rows) {
    @if (rows.length > 0) {
      <div class="bg-surface mt-4 shadow sm:rounded-lg overflow-hidden print:shadow-none">
        <div
          class="grid grid-cols-[minmax(50px,_2fr)_minmax(100px,_1fr)_minmax(100px,_1fr)] gap-2 p-4 group"
        >
          <div class=""></div>
          <div class="text-right text-sm font-semibold text-fg-primary">Einnahmen</div>
          <div class="text-right text-sm font-semibold text-fg-primary">Ausgaben</div>
        </div>
        @if (rows.length > 15) {
          <ng-container *ngTemplateOutlet="totalRow"></ng-container>
        }
        @for (row of rows; track row; let first = $first) {
          <button
            (click)="
              legalEntityFilter.next(
                row.legalEntityId && row.legalEntityDisplayName
                  ? { id: row.legalEntityId ?? '', displayName: row.legalEntityDisplayName ?? '' }
                  : unset
              )
            "
            [class.border-t]="first"
            class="w-full border-b border-edge grid grid-cols-[minmax(50px,_2fr)_minmax(100px,_1fr)_minmax(100px,_1fr)] gap-2 p-4 text-sm text-left font-normal text-fg-secondary hover:text-fg-primary hover:bg-surface-hover leading-4 group items-baseline"
          >
            <div class="truncate">
              {{ row.legalEntityDisplayName ? row.legalEntityDisplayName : '-' }}
            </div>
            @if (row.revenue) {
              <div class="text-right font-mono" [class.text-fg-faint]="row.revenue && row.expense">
                {{ row.revenue | number: '1.2-2' : 'de-CH' }}
                @if (row.revenue && row.expense && (row.revenue ?? 0) - (row.expense ?? 0) > 0) {
                  <div
                    class="pt-2 text-right text-sm font-mono text-fg-secondary group-hover:text-fg-primary"
                  >
                    {{ (row.revenue ?? 0) - (row.expense ?? 0) | number: '1.2-2' : 'de-CH' }}
                  </div>
                }
              </div>
            } @else {
              <div></div>
            }
            @if (row.expense) {
              <div class="text-right font-mono" [class.text-fg-faint]="row.revenue && row.expense">
                {{ row.expense | number: '1.2-2' : 'de-CH' }}
                @if (row.revenue && row.expense && (row.expense ?? 0) - (row.revenue ?? 0) > 0) {
                  <div
                    class="pt-2 text-right text-sm font-mono text-fg-secondary group-hover:text-fg-primary"
                  >
                    {{ (row.expense ?? 0) - (row.revenue ?? 0) | number: '1.2-2' : 'de-CH' }}
                  </div>
                }
              </div>
            } @else {
              <div></div>
            }
          </button>
        }
        <ng-container *ngTemplateOutlet="totalRow"></ng-container>
      </div>
    } @else {
      nichts
    }
  }
}

<ng-template #totalRow>
  <div
    class="grid grid-cols-[minmax(50px,_2fr)_minmax(100px,_1fr)_minmax(100px,_1fr)] sm:grid-cols-[minmax(50px,_1fr)_minmax(50px,_1fr)_minmax(50px,_1fr)_minmax(50px,_2fr)_minmax(100px,_1fr)_minmax(100px,_1fr)] p-4 gap-2 bg-surface font-medium"
  >
    <div class="text-sm = text-fg-secondary">Total</div>
    <div class="hidden sm:block"></div>
    <div class="hidden sm:block"></div>
    <div class="hidden sm:block"></div>

    @if (total$ | async; as total) {
      <div class="text-right text-sm text-fg-secondary font-mono">
        {{ total.revenue | number: '1.2-2' : 'de-CH' }}
        @if (total.revenue - total.expense > 0) {
          <div class="pt-2 text-right text-sm text-fg-primary font-mono">
            {{ total.revenue - total.expense | number: '1.2-2' : 'de-CH' }}
          </div>
        }
      </div>
      <div class="text-right text-sm text-fg-secondary font-mono">
        {{ (total$ | async)?.expense | number: '1.2-2' : 'de-CH' }}
        @if (total.expense - total.revenue > 0) {
          <div class="pt-2 text-right text-sm text-red-600 font-mono">
            {{ total.expense - total.revenue | number: '1.2-2' : 'de-CH' }}
          </div>
        }
      </div>
    }
  </div>
</ng-template>
